import axios, { AxiosResponse } from "axios";

export const instance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export const instanceForBi = axios.create({
  baseURL: import.meta.env.VITE_DIANN_SEARCH_API_URL,
});

export const instanceForAws = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

// 요청 인터셉터
instance.interceptors.request.use(
  async function (config) {
    // 스토리지에서 토큰을 가져온다.
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      config.headers.Authorization = accessToken;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  function (response) {
    if (response?.data) {
      response.data.success =
        [200, 201].includes(response.status) &&
        response.data.code?.startsWith("S");
      return response;
    } else {
      console.error(response);
      return {
        data: { success: false, code: "E" },
      } as AxiosResponse;
    }
  },
  async function (error) {
    const originalRequest = error.config;

    // response가 없는 경우 (네트워크 에러 등) 바로 에러 반환
    if (!error.response) {
      return Promise.reject(error);
    }

    const { status } = error.response;

    // 401 에러이고 재시도하지 않은 요청인 경우
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");

        // refreshToken이 없는 경우 로그인 페이지로 리다이렉션
        if (!refreshToken) {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login";
          return Promise.reject(error);
        }

        // 토큰 갱신 요청
        const response = await axios
          .create({
            baseURL: import.meta.env.VITE_BASE_API_URL,
            headers: {
              "Content-Type": "application/json",
              AuthorizationR: refreshToken,
            },
          })
          .get("/api/user/refresh-token");

        // 토큰 갱신 성공
        if (response.data.code?.startsWith("S")) {
          const { accessToken, refreshToken } = response.data.data;
          localStorage.setItem("accessToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);

          // 원래 요청의 헤더에 새 토큰 설정
          originalRequest.headers.Authorization = accessToken;

          // 원래 요청 재시도
          return instance(originalRequest);
        } else {
          // 토큰 갱신 실패
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login";
          return Promise.reject(error);
        }
      } catch (refreshError) {
        // 토큰 갱신 요청 자체가 실패한 경우
        console.error("Token refresh failed:", refreshError);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // 401 이외의 에러는 그대로 반환
    return Promise.reject(error);
  }
);
